export default "__VITE_ASSET__B7ZP7ubo__"